import { render, staticRenderFns } from "./AsideComponent.vue?vue&type=template&id=cfa84a70&scoped=true"
import script from "./AsideComponent.vue?vue&type=script&lang=js"
export * from "./AsideComponent.vue?vue&type=script&lang=js"
import style0 from "./AsideComponent.vue?vue&type=style&index=0&id=cfa84a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa84a70",
  null
  
)

export default component.exports